const EVENT_VISIBILITY = {
	PUBLIC:  'public',
	HIDDEN:  'hidden',
	PRIVATE: 'private',
};

const EVENT_VOD_STATUS = {
	AVAILABLE:    'available',
	FAILURE:      'failure',
	INAPPLICABLE: 'inapplicable',
	PROCESSING:   'processing',
};

export { EVENT_VISIBILITY, EVENT_VOD_STATUS };
